import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { LegalBasis } from './types';

export const legalBasesApi = createApi({
  reducerPath: 'legalBasesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/legal-bases`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  tagTypes: ['LegalBasis'],
  endpoints: builder => ({
    getLegalBases: builder.query<LegalBasis[], void>({
      query: () => ({ url: '/' }),
      providesTags: () => ['LegalBasis'],
    }),
    getLegalBaseById: builder.query<LegalBasis, string>({
      query: id => ({ url: `/${id}` }),
      providesTags: (_, __, id) => [{ type: 'LegalBasis', id }],
    }),
    getLegalBasesI: builder.infiniteQuery<
      LegalBasis[],
      FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '/',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['LegalBasis'],
    }),
  }),
});

export const { useGetLegalBasesQuery, useGetLegalBaseByIdQuery } =
  legalBasesApi;

export const useGetLegalBasesInfiniteQuery =
  normalizeInfiniteQueryData<LegalBasis>(
    legalBasesApi.useGetLegalBasesIInfiniteQuery,
  );
